export const getPaginationInfo = (page: number, pageSize: number, totalPage: number) => {
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, totalPage);
  const isNotFirstPage = page > 1;
  const isNotLastPage = page < Math.ceil(totalPage / pageSize);
  return { from, to, isNotFirstPage, isNotLastPage };
};
